import { PagesizeType } from '../../service/pagination/pagesize-type';
/* tslint:disable:no-access-missing-member */
import { Component, OnInit, AfterViewInit, Inject, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { List } from 'immutable';
import { ReservationCompare } from '../../models/reservation-compare';
import { ReservationUtils } from '../../utils/reservation-utils';
import { MatchTypeEnum } from '../../models/match-type.enum';
import { NumberUtils } from '../../../shared/utils/number.util';
import { Reservation } from '../../models/reservation';
import { SummaryRecordTypeEnum } from '../../models/summary-record-type.enum';
import { CompareTableAbstract } from '../../compare-table-abstract';
import { ReservationCompareStore } from '../../service/reservation-compare-store';
import { TranslateService } from '@ngx-translate/core';
import { LogService } from '../../../shared/log/log.service';
import { PageScrollService } from 'ng2-page-scroll';
import { DOCUMENT } from '@angular/platform-browser';
import { RsvpStore } from '../../service/rsvp.store';
import { Page } from '../../../shared/models/page';
import { Subscription } from 'rxjs/Subscription';
import { UserLocalStorageService } from '../../../permission/services/user.local.storage.service';

@Component({
  selector: 'pioneer-reservation-detail-table',
  templateUrl: './reservation-detail-table.component.html',
  styleUrls: [ './reservation-detail-table.component.css' ]
})
export class ReservationDetailTableComponent extends CompareTableAbstract implements OnInit, AfterViewInit, OnDestroy {

  private reservationCompareList: Observable<List<ReservationCompare>>;

  public ui = {
    showCards: false,
    showNoMatchesCard: false,
    showNoMatchesDetails: false,
    showNoMatchesWarningCard: false,
    showPartialMatchesCard: false,
    showPartialMatchesDetails: false,
    showPartialMatchesWarningCard: false,
    showExactMatchesCard: false,
    showExactMatchesDetails: false,
    showExactMatchesWarningCard: false,
    showNoReservationsWarning: false
  };

  public noMatchPage: Page<ReservationCompare>;
  public partialMatchPage: Page<ReservationCompare>;
  public exactMatchPage: Page<ReservationCompare>;

  noMatchespagesizeType = PagesizeType.GROUP_RESERVATIONS_NO_MATCHES;
  partialMatchespagesizeType = PagesizeType.GROUP_RESERVATIONS_PARTIAL_MATCHES;
  exactMatchespagesizeType = PagesizeType.GROUP_RESERVATIONS_EXACT_MATCHES;

  private matchSubscription: Subscription = new Subscription();

  constructor(private reservationCompareStore: ReservationCompareStore,
    private translateService: TranslateService,
    private logService: LogService,
    pageScrollService: PageScrollService,
    @Inject(DOCUMENT) document: any,
    rsvpStore: RsvpStore,
    private userLocalStorageService: UserLocalStorageService) {
    super(pageScrollService,
      document,
      rsvpStore);
    }

  ngOnInit() {
    this.reservationCompareList = this.reservationCompareStore.getReservationList();

    // all cards
    this.isReservationCompareListEmpty().subscribe((value: boolean) => {
      this.ui.showNoReservationsWarning = value;
      this.ui.showCards = !value;
    });

    // no matches
    this.isUnfilteredMatchListEmpty(MatchTypeEnum.NO_MATCH).subscribe((value: boolean) => {
      this.ui.showNoMatchesCard = !value;
    });
    this.isFilteredMatchListEmpty(MatchTypeEnum.NO_MATCH).subscribe((value: boolean) => {
      this.ui.showNoMatchesDetails = !value;
      this.ui.showNoMatchesWarningCard = value;
    });

    // partial matches
    this.isUnfilteredMatchListEmpty(MatchTypeEnum.PARTIAL_MATCH).subscribe((value: boolean) => {
      this.ui.showPartialMatchesCard = !value;
    });
    this.isFilteredMatchListEmpty(MatchTypeEnum.PARTIAL_MATCH).subscribe((value: boolean) => {
      this.ui.showPartialMatchesDetails = !value;
      this.ui.showPartialMatchesWarningCard = value;
    });

    // exact matches
    this.isUnfilteredMatchListEmpty(MatchTypeEnum.EXACT_MATCH).subscribe((value: boolean) => {
      this.ui.showExactMatchesCard = !value;
    });
    this.isFilteredMatchListEmpty(MatchTypeEnum.EXACT_MATCH).subscribe((value: boolean) => {
      this.ui.showExactMatchesDetails = !value;
      this.ui.showExactMatchesWarningCard = value;
    });

    this.headerRecordType = SummaryRecordTypeEnum.RESERVATION;


    this.noMatchPage = Page.empty<ReservationCompare>();
    this.noMatchPage.size = this.userLocalStorageService.getPagesize(PagesizeType.GROUP_RESERVATIONS_NO_MATCHES);
    this.buildMatchPage(this.noMatchPage, MatchTypeEnum.NO_MATCH);

    this.partialMatchPage = Page.empty<ReservationCompare>();
    this.partialMatchPage.size = this.userLocalStorageService.getPagesize(PagesizeType.GROUP_RESERVATIONS_PARTIAL_MATCHES);
    this.buildMatchPage(this.partialMatchPage, MatchTypeEnum.PARTIAL_MATCH);

    this.exactMatchPage = Page.empty<ReservationCompare>();
    this.exactMatchPage.size = this.userLocalStorageService.getPagesize(PagesizeType.GROUP_RESERVATIONS_EXACT_MATCHES);
    this.buildMatchPage(this.exactMatchPage, MatchTypeEnum.EXACT_MATCH);
  }

  buildMatchPage(matchPage: Page<ReservationCompare>, matchType: MatchTypeEnum) {
    this.matchSubscription.add(this.getMatches(matchType).subscribe((reservationList: List<ReservationCompare>) => {
      const rsvpId = this.reservationCompareStore.selectedRsvpId;
      const reservationId = this.reservationCompareStore.selectedReservationId;
      if (reservationId) {
        const index = reservationList.findIndex((compare: ReservationCompare) =>
          compare.reservation && compare.reservation.eventReservationId === reservationId);
        if (index >= 0) {
          matchPage.number = Math.floor(index / matchPage.size);
        }
      } else if (rsvpId) {
        const index = reservationList.findIndex((compare: ReservationCompare) =>
          compare.rsvp && compare.rsvp.eventRsvpId === rsvpId);
        if (index >= 0) {
          matchPage.number = Math.floor(index / matchPage.size);
        }
      }

      const page = matchPage.number;
      const itemsPerPage = matchPage.size;

      matchPage.content = List<ReservationCompare>(
        reservationList.slice(page * itemsPerPage, (page + 1) * itemsPerPage)
      );
      matchPage.totalElements = reservationList.size;
      matchPage.numberOfElements = matchPage.content.size;
    }));
  }

  ngAfterViewInit() {
    const rsvpId = this.reservationCompareStore.selectedRsvpId;
    const reservationId = this.reservationCompareStore.selectedReservationId;
    this.logService.verbose(`rsvp: ${rsvpId}, reservation: ${reservationId}`);

    let elem: Element;
    if (reservationId) {
      const id = this.getReservationId(reservationId);
      elem = document.querySelector(`[data-res-id=${id}]`);
      elem.classList.add('highlight');
      this.logService.verbose(`page scrolling to selector: [data-res-id=${id}]`);
      this.scrollToElement(<HTMLElement>elem);
    } else if (rsvpId) {
      const id = this.getRsvpId(rsvpId);
      elem = document.querySelector(`[data-rsvp-id=${id}]`);
      elem.classList.add('highlight');
      this.logService.verbose(`page scrolling to selector: [data-rsvp-id=${id}]`);
      this.scrollToElement(<HTMLElement>elem);
    }
  }

  ngOnDestroy(): void {
    this.matchSubscription.unsubscribe();
  }

  private getFilteredComparisonList(): Observable<List<ReservationCompare>> {
    return this.reservationCompareStore.getCurrentFilteredReservations();
  }

  getMatches(matchType: MatchTypeEnum): Observable<List<ReservationCompare>> {
    return this.getFilteredComparisonList().map((comparisonList: List<ReservationCompare>) => {
      return comparisonList.filter((comparison: ReservationCompare) => comparison.matchType === matchType.toString()).toList();
    });
  }

  private getUnfilteredMatches(matchType: MatchTypeEnum): Observable<List<ReservationCompare>> {
    return this.reservationCompareList.map((comparisonList: List<ReservationCompare>) => {
      return comparisonList.filter((comparison: ReservationCompare) => comparison.matchType === matchType.toString()).toList();
    });
  }

  getReservationTotalCommission(matchType: MatchTypeEnum): Observable<number> {
    return ReservationUtils.calculateCommissionTotal(this.getUnfilteredMatches(matchType));
  }

  getReservationId(value: Reservation | number) {
    let reservationId: number;
    if (typeof value === 'number') {
      reservationId = <number>value;
    } else if (value) {
      reservationId = value.eventReservationId;
    } else {
      return '';
    }

    if (reservationId) {
      return `res-${reservationId}`;
    } else {
      return '';
    }
  }

  getRsvpTotalCommission(matchType: MatchTypeEnum): Observable<number> {
    return ReservationUtils.calculateRsvpCommissionTotal(this.getUnfilteredMatches(matchType));
  }

  private isReservationCompareListEmpty(): Observable<boolean> {
    return ReservationUtils.isListEmpty(this.reservationCompareList);
  }

  private isFilteredMatchListEmpty(matchType: MatchTypeEnum): Observable<boolean> {
    return this.reservationCompareStore.isFilteredMatchListEmpty(matchType);
  }

  private isUnfilteredMatchListEmpty(matchType: MatchTypeEnum): Observable<boolean> {
    return ReservationUtils.isListEmpty(this.getUnfilteredMatches(matchType));
  }

  hasFilteredOutResults(): Observable<boolean> {
    return ReservationUtils.isListEmpty(this.getFilteredComparisonList()).flatMap(filteredListIsEmpty => {
      return this.isReservationCompareListEmpty().map(isReservationListEmpty => filteredListIsEmpty !== isReservationListEmpty);
    });
  }

  getCommissionDelta(matchType: MatchTypeEnum): Observable<number> {
    const reservationCommissionObj = this.getReservationTotalCommission(matchType);
    const rsvpCommissionObj = this.getRsvpTotalCommission(matchType);

    return reservationCommissionObj.flatMap(reservationCommission => {
      return rsvpCommissionObj.map(rsvpCommission => {
        return reservationCommission - rsvpCommission;
      });
    }).map(total => NumberUtils.round2Fixed(total));
  }

  getCommissionDeltaText(matchType: MatchTypeEnum): Observable<string> {
    return this.getCommissionDelta(matchType).flatMap(delta => {
      if (delta > 0) {
        return this.translateService.get('EVENT.RESERVATION.TOOLTIP_COMMISSION_DIFFERENCE_MORE');
      } else if (delta < 0) {
        return this.translateService.get('EVENT.RESERVATION.TOOLTIP_COMMISSION_DIFFERENCE_LESS');
      } else {
        return this.translateService.get('EVENT.RESERVATION.TOOLTIP_COMMISSION_DIFFERENCE_EQUAL');
      }
    });
  }

  resetStatusCodes(): void {
    this.reservationCompareStore.resetStatusCodes();
  }

  getNoMatchCardHeaderTitle(): Observable<string> {
    return this.reservationCompareStore.areRsvpsPresent().map(result => {
      return result ? 'EVENT.RESERVATION.NO_MATCH_TITLE' : 'EVENT.RESERVATION.NO_RSVP_TITLE';
    });
  }

  updateRsvp(rsvpToUpdate: ReservationCompare): Observable<boolean> {
    const obs$ = super.updateRsvp(rsvpToUpdate);
    obs$.subscribe(() => {
      this.reservationCompareStore.refreshCurrentReservationList(this.onyxEvent.eventId);
    });
    return obs$;
  }

  private onRefreshMatchPage(pageNumber: number, itemsPerPage: number, matchType: MatchTypeEnum, page: Page<ReservationCompare>) {
    this.getMatches(matchType).take(1).subscribe(reservationList => {
      page.content = List<ReservationCompare>(
        reservationList.slice(pageNumber * itemsPerPage, (pageNumber + 1) * itemsPerPage)
      );
      page.number = pageNumber;
      page.size = itemsPerPage;
      page.totalElements = reservationList.size;
      page.numberOfElements = page.content.size;
    });
  }

  onRefreshNoMatchList(pageNumber: number, itemsPerPage: number) {
    this.onRefreshMatchPage(pageNumber, itemsPerPage, MatchTypeEnum.NO_MATCH, this.noMatchPage);
  }

  onRefreshPartialMatchList(pageNumber: number, itemsPerPage: number) {
    this.onRefreshMatchPage(pageNumber, itemsPerPage, MatchTypeEnum.PARTIAL_MATCH, this.partialMatchPage);
  }

  onRefreshExactMatchList(pageNumber: number, itemsPerPage: number) {
    this.onRefreshMatchPage(pageNumber, itemsPerPage, MatchTypeEnum.EXACT_MATCH, this.exactMatchPage);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/reservations/reservation-detail-table/reservation-detail-table.component.ts